import { logException } from 'lib/Sentry/logException';
import { DefaultErrorFallback } from 'lib/router/utils/getRouterOptionsWithDefaults/DefaultErrorFallback';

export const ErrorFallback = ({ error, retry }: { error: Error; retry: () => void }) => {
  logException(error);

  return <DefaultErrorFallback error={error} retry={retry} />;
};
